import {
  OFFER_STATUS
} from "../constants/offer.constants";

const STATUS_CONFIG = {
  [OFFER_STATUS.DRAFT]: {
    label: "Draft",
    className: "offer-status-badge--draft"
  },

  [OFFER_STATUS.SENT]: {
    label: "Sent",
    className: "offer-status-badge--sent"
  },

  [OFFER_STATUS.VIEWED]: {
    label: "Viewed",
    className: "offer-status-badge--viewed"
  },

  [OFFER_STATUS.ACCEPTED]: {
    label: "Accepted",
    className:
      "offer-status-badge--accepted"
  },

  [OFFER_STATUS.REJECTED]: {
    label: "Rejected",
    className:
      "offer-status-badge--rejected"
  },

  [OFFER_STATUS.EXPIRED]: {
    label: "Expired",
    className:
      "offer-status-badge--expired"
  },

  [OFFER_STATUS.CANCELLED]: {
    label: "Cancelled",
    className:
      "offer-status-badge--cancelled"
  }
};

const OfferStatusBadge = ({
  status
}) => {
  const config =
    STATUS_CONFIG[status] || {
      label: status || "Unknown",
      className: ""
    };

  return (
    <span
      className={`offer-status-badge ${config.className}`}
    >
      {config.label}
    </span>
  );
};

export default OfferStatusBadge;